export const AccountCancellationI18n = {
	zh: {
		accountCancellationTitle: '删除说明',
		accountCancellationTop: '当您注销应用账号时，通常意味着您将删除与该账号相关的所有个人信息和数据。',
		accountCancellationStepTitle: '具体步骤如下：',
		accountCancellationStep1: '1、打开链上会：首先，您需要打开应用程序并进入【安全中心】页面',
		accountCancellationStep2: '2、找到账号安全：在【安全中心】进行页面下拉操作，即可看到“注销账户”',
		accountCancellationStep3: '3、注销账号：点击“注销账户”按钮',
		accountCancellationStep4: '4、确认注销：在删除账号之前，您可能会收到一个确认对话框或消息，以确保您确实想要删除该账号及其相关数据。请仔细阅读提示并确认您的操作',
		accountCancellationStep5: '5、完成注销：一旦您确认注销操作，应用程序将删除与该账号相关的所有个人信息和数据，并从您的设备中删除该账号的记录',
		accountCancellationExample: '示例图如下：',
		accountCancellationExampleTip: '如果您不确定如何删除应用程序的账号，可像我们提交账号信息，我们工作人员会在向您核实后进行删除操作',
		accountCancellationSubmit1: '姓名',
		accountCancellationSubmit2: '联系电话',
		accountCancellationSubmit3: '账号',
		accountCancellationSubmit4: '备注',
		accountCancellationSubmit1placeholder: '请输入姓名',
		accountCancellationSubmit2placeholder: '请输入联系电话',
		accountCancellationSubmit3placeholder: '请输入账号',
		accountCancellationSubmit4placeholder: '请输入备注',
		accountCancellationSubmit: '提 交',
		accountCancellationSubmitSuccess: '信息已提交',
	},
	en: {
		accountCancellationTitle: 'Delete instructions',
		accountCancellationTop: 'When you log out of an app account, it usually means that you will delete the of all personal information and data.',
		accountCancellationStepTitle: "Specific steps are as follows:",
		accountCancellationStep1: "1. Open the on-chain meeting: First, you need to open the application and enter the [Security Center] page",
		accountCancellationStep2: "2. Find account security: scroll down the page in [Security Center] and you will see 'Cancel Account'",
		accountCancellationStep3: "3. Cancel account: Click the 'Cancel Account' button",
		accountCancellationStep4: "4. Confirm logout: Before deleting the account, you may receive a confirmation dialog box or message to ensure that you really want to delete the account and its related data.Please read the tips carefully and confirm your operation",
		accountCancellationStep5: "5. Complete the logout: Once you confirm the logout operation, the application will delete all personal information and data related to the account and delete the record of the account from your device",
		accountCancellationExample: "The sample picture is as follows",
		accountCancellationExampleTip: "If you are not sure how to delete the application account, you can submit the account information to us, and our staff will verify it with you and then proceed with the deletion.",
		accountCancellationSubmit1: 'Name',
		accountCancellationSubmit2: 'Phone',
		accountCancellationSubmit3: 'Account',
		accountCancellationSubmit4: 'Remarks',
		accountCancellationSubmit1placeholder: 'Please enter name',
		accountCancellationSubmit2placeholder: 'Please enter phone number',
		accountCancellationSubmit3placeholder: 'Please enter account',
		accountCancellationSubmit4placeholder: 'Please enter remarks',
		accountCancellationSubmit: 'Submit',
		accountCancellationSubmitSuccess: 'Information submitted',
	}
}
